export enum RouteConstants {
    home = '/',
    unauthenticated = '/unauthenticated',
    accessDenied = '/accessDenied',
    login = '/login',
    clients = '/clients',
    addClient = '/clients/addClient',
    events = '/events',
    addEvent = '/events/addEvent',
    product = '/products',
    addProduct = '/products/addProduct',
    workersAndCarriers = '/workersAndCarriers',
    addContact = '/workersAndCarriers/addContact',
    statistics = '/statistics',
    invoices = '/invoices',
    emailsAndSurveys = '/emailsAndSurveys',
    settings = '/settings',
    administration = '/administration',
}

export enum RouteParameters {
    id = '/:id',
}
